/* eslint-disable @next/next/no-img-element */
import clsx from 'clsx';

import { ClassNameProps } from '@/types/common.types';

import { TransformedSubscription } from '@/api/types/user.types';

import { IconsEnum } from '@/enums/subscription-type.enums';

import styles from '@/components/SubscriptionCards/SubscriptionIconsList.module.scss';

// -----------------------------------------------------------------

type SubscriptionIconsListProps = ClassNameProps & {
  icons: TransformedSubscription['icons'];
};

// -----------------------------------------------------------------

export const SubscriptionIconsList = (props: SubscriptionIconsListProps) => {
  const { icons, className } = props;

  return (
    <ul className={clsx(styles.iconsList, className)}>
      {icons?.map((icon, index) => {
        return (
          <li
            key={icon.name}
            className={clsx(styles.iconItem, {
              [styles.lastItem]: index === icons?.length - 1,
            })}
          >
            <img
              src={icon.src}
              alt={icon.name}
              style={{
                height:
                  icon.name.startsWith(IconsEnum.Amediateka) ||
                  icon.name.startsWith(IconsEnum.STANDART)
                    ? 12
                    : 16,
              }}
            />
          </li>
        );
      })}
    </ul>
  );
};
